import { Host, Picker } from '@expo/ui';

import type { ProfileScopeControlProps } from './profile-scope-control.types';

export function ProfileScopeControl({
  maxWidth,
  onValueChange,
  options,
  selectedValue,
  testID,
}: Readonly<ProfileScopeControlProps>) {
  return (
    <Host matchContents style={{ maxWidth }}>
      <Picker
        selectedValue={selectedValue}
        onValueChange={onValueChange}
        appearance="menu"
        testID={testID}
      >
        {options.map((option) => (
          <Picker.Item key={option.value} label={option.label} value={option.value} />
        ))}
      </Picker>
    </Host>
  );
}

export type { ProfileScopeControlProps, ProfileScopeOption } from './profile-scope-control.types';
